import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Card, CardMedia, CardContent, Typography } from '@mui/material';
import { auth, db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

const MyBooks = () => {
  const navigate = useNavigate();
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const userId = auth.currentUser?.uid;
        if (!userId) {
          navigate('/login');
          return;
        }

        const q = query(
          collection(db, 'books'),
          where('uid', '==', userId)
        );

        const querySnapshot = await getDocs(q);
        const bookList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setBooks(bookList);
      } catch (error) {
        console.error('책 목록 불러오기 오류:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBooks();
  }, [navigate]);

  if (loading) {
    return <Box sx={{ p: 3 }}>로딩 중...</Box>;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>내 서재</Typography>
      <Grid container spacing={2}>
        {books.map((book) => (
          <Grid item xs={12} sm={6} md={4} key={book.id}>
            <Card 
              sx={{ 
                height: '100%', 
                cursor: 'pointer',
                '&:hover': { transform: 'scale(1.02)', transition: 'transform 0.2s' }
              }}
              onClick={() => navigate(`/book/${book.id}`)}
            >
              <CardMedia
                component="img"
                height="200"
                image={book.thumbnail || '/default-book.png'}
                alt={book.title}
                sx={{ objectFit: 'contain', bgcolor: '#f5f5f5' }}
              />
              <CardContent>
                <Typography variant="h6" noWrap>{book.title}</Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                  {book.authors}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {book.publisher}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {books.length === 0 && (
        <Typography sx={{ mt: 3, textAlign: 'center' }}>
          등록된 책이 없습니다.
        </Typography>
      )}
    </Box>
  );
};

export default MyBooks; 